import React, { useState } from 'react';

// Material
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

// Components
import ProductsTable from './productTable';
import { utils } from '../../../../utils/utils';
import { Typography, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const PromotionItem = ({ promotion, currency, onDelete, onAdd, disabled }) => {
    const [open, setOpen] = useState();

    return (
        <Grid container alignItems='center' size={12}>
            <Grid wrap='nowrap' size={6}>
                <Typography component='span' variant='body1'>
                    <strong>{promotion.title}</strong>
                </Typography>
            </Grid>
            <Grid wrap='nowrap' size={(onDelete || onAdd) ? 4 : 6}>
                {
                    promotion.discount > 0 &&
                    <Typography align='right'>
                        {currency} <strong>{utils.formatMoney(promotion.discount)}</strong>
                    </Typography>
                }
                {
                    promotion.discount <= 0 &&
                    <Typography align='right'>
                        ---
                    </Typography>
                }
            </Grid>
            {   onDelete &&
                <Grid size={2}>
                    <Box display='flex' justifyContent='flex-end'>
                        <IconButton
                            color='primary'
                            size='small'
                            onClick={() => onDelete(promotion)}
                            disabled={disabled}
                        >
                            <DeleteIcon />
                        </IconButton>
                        <IconButton
                            color='primary'
                            size='small'
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </Box>
                </Grid>
            }
            {   onAdd &&
                <Grid size={2}>
                    <Box display='flex' justifyContent='flex-end'>
                        <IconButton
                            color='primary'
                            size='small'
                            onClick={() => onAdd(promotion)}
                        >
                            <AddIcon />
                        </IconButton>
                    </Box>
                </Grid>
            }
            {   promotion.items?.length > 0 &&
                <Grid size={12}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <ProductsTable promotion={promotion} items={promotion.items} currency={currency} promotionId={promotion.id} />
                    </Collapse>
                </Grid>
            }
            <Grid size={12}>
                <Typography variant='caption' display='block'>
                    {promotion.description}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default PromotionItem;